export const updateShipmentVisitDeliveryEndpoint = (shipmentUid: string, visitId: string) =>
  `/shipments/${shipmentUid}/visits/${visitId}`
